export default __webpack_public_path__ + "media/images/features/jtb/osaki-6a04dbf213f364e3b7d08d5cc135540f.png";